export const STRING_LIST_TYPE: { [name: string]: string } = {
  SAME_LINE: "SAME_LINE",
  NEW_LINE: "NEW_LINE",
};

export const STRING_LIST_TYPES = Object.values(STRING_LIST_TYPE);
